import LocalizedMessage from '../common/LocalizedMessage';
import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

const getSaveBarMessage = (dirty, validation, validationAttempted, tr) => {
  if (validationAttempted) {
    return "";
  }

  if (validation.unmarkedCount > 0) {
    return tr('manage:attendance.remaining', { count: validation.unmarkedCount });
  }

  return tr(dirty ? 'manage:attendance.dirty' : 'manage:attendance.ready');
};

function AttendanceSaveBar({
  canEdit,
  dirty,
  validation,
  validationAttempted,
  saving,
  onSave,
  onReturn,
}) {
  const { t: tr } = useTranslation();
  const message = getSaveBarMessage(dirty, validation, validationAttempted, tr);

  return (
    <div className="attendance-page__save-bar">
      <div className="attendance-page__save-actions">
        <button type="button" className="btn manage-button manage-red-button" disabled={saving || !canEdit} onClick={onSave}>
          {saving ? tr('manage:attendance.saving') : tr("manage:saveAttendance_63")}
        </button>
        <button type="button" className="btn manage-button manage-teal-button" disabled={saving} onClick={onReturn}>{tr("common:back")}</button>
      </div>
      {message && (
        <div className="attendance-page__save-message">
          <LocalizedMessage value={message} />
        </div>
      )}
    </div>
  );
}

AttendanceSaveBar.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  dirty: PropTypes.bool.isRequired,
  validation: PropTypes.object.isRequired,
  validationAttempted: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onReturn: PropTypes.func.isRequired,
};

export default AttendanceSaveBar;
